export default "__VITE_ASSET__BsJzFMAl__"